module.exports = __webpack_public_path__ + "static/media/27OCHA16.1322d83d.jpg";